module.exports = __webpack_public_path__ + "static/img/logo_solgas_png.93b0fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading/logo_solgas_png.png
// module id = 06y6
// module chunks = 3